import React, { useState } from 'react'
import { connect } from 'react-redux'
import {
  ListItemIcon,
  ListItemText,
  Menu,
  MenuList,
  MenuItem
} from '@material-ui/core'
import {
  ContactIcon,
  ContactPersonIcon,
  ProjectIcon,
  DepartmentIcon,
  SettingsIcon
} from '../icons/index.js'
import redux from '../redux/index.js'

const Toolbar = ({
  strings,
  sharePointSaveEnabled,
  selected,
  currentPage,
  onSetCurrentPage,
  onResetSearch,
  onShowSettingsDialog,
  menuAnchorEl,
  onMenuClose,
  children
}) => {
  const [internalAnchorEl, setInternalAnchorEl] = useState(null)
  const anchorEl = typeof menuAnchorEl !== 'undefined' ? menuAnchorEl : internalAnchorEl
  const handleCloseMenu = () => {
    if (typeof onMenuClose === 'function') {
      onMenuClose()
    } else {
      setInternalAnchorEl(null)
    }
  }

  const onMenuSelect = (page) => {
    handleCloseMenu()
    onResetSearch()
    if (page !== currentPage) {
      onSetCurrentPage(page)
    }
  }

  const onSettingsSelect = () => {
    handleCloseMenu()
    onShowSettingsDialog()
  }

  const onContactManagerSelect = () => {
    handleCloseMenu()
    const targetUrl = getContactManagerUrl(process.env.REACT_APP_CM_URL, selected)
    if (targetUrl) {
      window.open(targetUrl, '_new', 'noopener,noreferrer')
    }
  }

  const renderIntranetMenuitem = () => {
    if (sharePointSaveEnabled) {
      return (
        <MenuItem
          selected={currentPage === 'intranet'}
          onClick={() => onMenuSelect('intranet')}
        >
          <ListItemIcon style={menuIconStyle}><DepartmentIcon /></ListItemIcon>
          <ListItemText primary={strings.intranet_page_title} />
        </MenuItem>
      )
    } else {
      return null
    }
  }

  const renderMenu = () => {
    return (
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        <MenuList style={menuListStyle}>
          <MenuItem
            selected={currentPage === 'contact'}
            onClick={() => onMenuSelect('contact')}
          >
            <ListItemIcon style={menuIconStyle}><ContactIcon /></ListItemIcon>
            <ListItemText primary={strings.contact_page_title} />
          </MenuItem>
          <MenuItem
            selected={currentPage === 'project'}
            onClick={() => onMenuSelect('project')}
          >
            <ListItemIcon style={menuIconStyle}><ProjectIcon /></ListItemIcon>
            <ListItemText primary={strings.project_page_title} />
          </MenuItem>
          {renderIntranetMenuitem()}
          <MenuItem onClick={onContactManagerSelect}>
            <ListItemIcon style={menuIconStyle}><ContactPersonIcon /></ListItemIcon>
            <ListItemText primary={strings.contact_manager_menu_title || 'Contact manager'} />
          </MenuItem>
        </MenuList>
        <MenuList style={{ padding: '0px' }}>
          <MenuItem
            onClick={onSettingsSelect}
          >
            <ListItemIcon style={menuIconStyle}><SettingsIcon /></ListItemIcon>
            <ListItemText primary={strings.settings_dialog_title} />
          </MenuItem>
        </MenuList>
      </Menu>
    )
  }

  return (
    <div style={toolbarStyle}>
      <div>
        {renderMenu()}
      </div>
      <div style={contentOffsetStyle}>{children}</div>
    </div>
  )
}

const menuListStyle = {
  borderBottom: '0.25px solid #c7c7c7',
  padding: '0px'
}

const MENU_ICON_COLOR = '#447fb1'

const menuIconStyle = {
  color: MENU_ICON_COLOR
}

const toolbarStyle = {
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'flex-start',
  background: '#f4f4f4',
  height: 40
}

const contentOffsetStyle = {
  marginLeft: 10,
  display: 'flex',
  alignItems: 'center',
  width: '100%'
}

function getContactManagerUrl (baseUrl, selected) {
  const cleanBaseUrl = String(baseUrl || '').trim()
  if (!cleanBaseUrl.length) {
    return ''
  }

  let parsed
  try {
    parsed = new URL(cleanBaseUrl)
  } catch {
    return cleanBaseUrl
  }

  const selectedId = selected?.id != null ? String(selected.id) : ''
  const selectedType = selected?.type

  if (!selectedId.length) {
    return parsed.toString()
  }

  if (selectedType === 'project') {
    parsed.pathname = joinPathname(parsed.pathname, '/projects/edit')
    parsed.search = `id=${encodeURIComponent(selectedId)}`
    return parsed.toString()
  }

  if (selectedType === 'contact') {
    parsed.pathname = joinPathname(parsed.pathname, '/contacts/edit')
    parsed.search = `id=${encodeURIComponent(selectedId)}`
    return parsed.toString()
  }

  return parsed.toString()
}

function joinPathname (basePathname, suffixPathname) {
  const base = String(basePathname || '').replace(/\/+$/, '')
  const suffix = String(suffixPathname || '').replace(/^\/+/, '')
  const joined = `${base}/${suffix}`
  return joined.startsWith('/') ? joined : `/${joined}`
}

const mapStateToProps = (state) => {
  return {
    currentPage: state.page,
    selected: state.selected.current,
    strings: state.locale.strings,
    sharePointSaveEnabled: state.login.userData.sharePointSaveEnabled
  }
}

const mapDispatchToProps = (dispatch) => {
  const { dialog, files, page, selected } = redux.actions
  return {
    onSetCurrentPage: (p) => {
      dispatch(files.resetSelectedFile())
      if (p !== 'templates') {
        dispatch(selected.resetSelectedItem())
      }
      dispatch(page.setCurrentPage(p))
    },
    onShowSettingsDialog: () => {
      dispatch(dialog.showSettingsDialog())
    },
    onResetSearch: () => {
      dispatch(files.resetSearch())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar)
